var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardPerfilIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36.004,
    viewBox: "0 0 36 36.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twotone-closed_caption-24px",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4929",
    "data-name": "Caminho 4929",
    d: "M0,0H36V36H0Z",
    transform: "translate(0 0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4930",
    "data-name": "Caminho 4930",
    d: "M19.88,6.08,6,19.567v1.551H7.6L21.477,7.631Z",
    transform: "translate(3.443 0.718)",
    fill: "rgba(46,128,195,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4931",
    "data-name": "Caminho 4931",
    d: "M17.75,4.47,4,18.22v5.156H9.156l13.75-13.75ZM8.015,20.627H6.75V19.362l11-11,1.265,1.265ZM26.977,5.556a1.369,1.369,0,0,0,0-1.939L23.759.4a1.369,1.369,0,0,0-1.939,0l-2.7,2.7,5.156,5.156Z",
    transform: "translate(4.499)",
    fill: "#2e80c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4932",
    "data-name": "Caminho 4932",
    d: "M0,20H36v5.5H0Z",
    transform: "translate(0 10.501)",
    fill: "rgba(46,128,195,0.3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPerfilIcon);
export default __webpack_public_path__ + "static/media/card-perfil-icon.84d575687d485d2f2dd0f69908cad642.svg";
export { ForwardRef as ReactComponent };